export default function CheckCircle({ className, backgroundColor }) {
    return (
      <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_82_763)">
          <circle cx="8" cy="8" r="8" fill={backgroundColor} />
          <path d="M5 7.65517L7.21739 10L11 6"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round" />
        </g>
        <defs>
          <clipPath id="clip0_82_763">
            <rect width="16" height="16" fill={backgroundColor} />
          </clipPath>
        </defs>
      </svg>
    )
}
